<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
.form-success {
    background-color: red;

    @screen md {
        max-width: 460px;
    }
}

</style>
